import type { InferGetStaticPropsType } from 'next';
import Head from 'next/head';
import type { ReactElement } from 'react';

import BlogsList from '@/components/Blog/BlogsList';
import Layout from '@/components/Landing/Layout';
import { getStaticBlogsListProps } from '@/utils/getStaticBlog';
import { createBreadcrumbSchema } from '@/utils/schema-org';
import { createMetaTags } from '@/utils/seo';

const AiCompany = ({
  initialPages,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  return (
    <>
      <Head>
        {createMetaTags({
          title: 'AI Company. Gateway to Automation',
          description:
            'Insights on AI automation, intelligent agents, and HR tech for companies building the future of work.',
        })}
        <link
          rel="canonical"
          href="https://mindpal.co/ai-company"
          key="canonical"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'CollectionPage',
              name: 'AI Company — MindPal',
              description:
                'Insights on AI automation, intelligent agents, and HR tech — for companies building the future of work.',
              url: 'https://mindpal.co/ai-company',
              publisher: {
                '@type': 'Organization',
                name: 'MindPal',
                url: 'https://mindpal.co',
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(createBreadcrumbSchema('/ai-company')),
          }}
        />
      </Head>
      <BlogsList
        initialPages={initialPages}
        blogType="AICOMPANY"
        title="AI Company"
        description="AI Company is MindPal's editorial hub covering artificial intelligence, automation, and the future of work — written for founders, recruiters, and product teams."
      />
    </>
  );
};

export default AiCompany;

AiCompany.getLayout = (page: ReactElement) => (
  <Layout theme="light">{page}</Layout>
);

export const getStaticProps = async () => {
  const { initialPages } = await getStaticBlogsListProps({
    blogType: 'AICOMPANY',
  });

  return { props: { initialPages }, revalidate: 30 };
};
